// extracted by mini-css-extract-plugin
export default {"Header":"AppSimplePage__Header__2vnPc","LogoWrapper":"AppSimplePage__LogoWrapper__2HcPJ","Sidebar":"AppSimplePage__Sidebar__2qFmF","Content":"AppSimplePage__Content__2RhvV"};